import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/api/client";
import { useAuth } from "@/context/AuthContext";

/**
 * Handles the Emergent Google Auth callback (URL fragment #session_id=...).
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const { refresh } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m?.[1];
    if (!session_id) {
      setError("Missing session_id");
      return;
    }

    (async () => {
      try {
        await api.post("/auth/session", null, {
          headers: { "X-Session-ID": session_id },
        });
        localStorage.setItem("has_session", "1");
        // clear the fragment
        window.history.replaceState({}, document.title, window.location.pathname);
        await refresh();
        toast.success("¡Bienvenido!");
        navigate("/admin", { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || "Auth failed");
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-halftone">
      <div className="brutal p-8 text-center max-w-md">
        <div className="font-display font-black text-2xl mb-2">
          {error ? "Auth error" : "Iniciando sesión…"}
        </div>
        <div className="font-body text-sm text-neutral-700">
          {error || "Un segundo, estamos verificando tu cuenta de Google."}
        </div>
      </div>
    </div>
  );
}
